module.exports = __webpack_public_path__ + "static/media/prospect_trial.581a741d.png";